import { customSanitize } from "../../utils/customSanitize";
import { optimizeURL } from "../../utils/url";
import styles from "./PostCard.module.scss";
import { ImageType } from "../../types/baseTypes";
import { WP_Term } from "wp-types";
import { ContentTag } from "../ContentTag/ContentTag";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { MediaFormatType } from "@/types/ModuleOptionsType";
import { Button } from "../Button/Button";
import { MediaItem } from "../MediaItem/MediaItem";

export type PostsGridElementType = {
  id: number;
  date: string;
  title: string;
  link: string;
  image: ImageType | false;
  excerpt: string;
  categories: WP_Term[];
  media_format?: MediaFormatType;
};

interface PostCardProps {
  element: PostsGridElementType;
  readMoreLabel?: string;
  border_radius: boolean;
  box_shadow: boolean;
  showBox: boolean;
  grid_columns: "two-cols" | "three-cols";
  media_format?: MediaFormatType;
}

const PostCard = ({
  element,
  readMoreLabel = "Read more",
  border_radius,
  box_shadow,
  showBox,
  grid_columns = "two-cols",
  media_format,
}: PostCardProps) => {
  const { excerpt, image, link, title } = element;
  const { getLabel } = useGlobalContext();
  // const filteredCategories = categories.filter(
  //   (el) => el.name !== "Unkategorisiert",
  // );

  // Todo: Remove this when postsslider have media_format set
  const defaultMediaFormat: MediaFormatType = {
    mobile: "square",
    tablet: "square",
    desktop: "square",
    fullhd: "square",
  };

  const optimizedURL = optimizeURL(link);
  return (
    <article
      className={`${styles["embla-slide"]} ${styles["slider-element"]} ${styles[grid_columns]} ${box_shadow && showBox ? "has-box-shadow" : ""} ${border_radius && showBox ? "has-border-radius" : ""} ${showBox ? "is-box" : ""} is-flex ${styles[image ? "has-image" : "no-image"]}`}
    >
      <section
        className={`${styles["info-wrapper"]} is-flex is-flex-direction-column is-align-items-center ${showBox ? "is-box" : ""}`}
      >
        <header>
          {/* <p className={styles["info-top"] + " pb-5"}>
            <span className={"date"}>
              <DateComponent
                date={new Date(element.date)}
                dateFormat={"dd. MMM yyyy"}
              />
            </span>
            {filteredCategories.length > 0 && (
              <span
                aria-hidden="true"
                className={styles.separator + " category"}
              >
                |
              </span>
            )}
            {filteredCategories.length > 0 &&
              filteredCategories.map((category, index) => {
                return (
                  <Fragment key={index}>
                    <span className="category">{category.name}</span>
                    {index < categories.length - 1 ? (
                      <span className={styles.separator + " category"}>|</span>
                    ) : null}
                  </Fragment>
                );
              })}
          </p> */}
          {title && (
            <p
              role="heading"
              aria-level={3}
              className={styles.title + " title pb-0 mb-4"}
              dangerouslySetInnerHTML={{
                __html: customSanitize(title),
              }}
            />
          )}
          {!image && excerpt && (
            <ContentTag
              content={excerpt}
              extraClass={styles["content"] + " pb-0 mb-4"}
            />
          )}
        </header>

        {link && (
          <footer className="mt-auto">
            <Button
              type="secondary"
              href={optimizedURL!}
              target="_self"
              className="my-0 pb-0"
              aria-label={getLabel("aria_label_postlink").replace(
                "$posttitle",
                title,
              )}
              disablePrefetch // Disable prefetching for grid links https://trello.com/c/g5k075FS
            >
              {readMoreLabel}
            </Button>
          </footer>
        )}
      </section>
      {image && (
        <MediaItem
          hasOverlay={false}
          image_desktop={image}
          mediaFormat={media_format ? media_format : defaultMediaFormat}
          sizes="(min-width: 768px) 33vw, 100vw"
          link={
            optimizedURL
              ? { url: optimizedURL, target: "_self", title: "" }
              : undefined
          }
          linkProps={{ tabIndex: -1 }}
          disablePrefetch // Disable prefetching for grid links https://trello.com/c/g5k075FS
        />
      )}
    </article>
  );
};

export default PostCard;
